<template>
  <v-flex>
    <div class="p-t-20">
      <div class="tituloBox border-top">
        <div class="bg-red barraTitulo"></div>
        <h1 class="text-default font-size-14">
          <strong>Dirigentes</strong>
        </h1>
      </div>
    </div>
    <div class="clear"></div>
    <v-data-table
      :headers="headers"
      :items="habilitacaoLista.dirigentesLista"
      :loading="loading"
      :hide-actions="true"
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <td class="justify-center layout px-0">
          <v-icon @click="deleteItem(props.item)" :size="20">delete</v-icon>
        </td>
        <td class="text-xs-left">{{ props.item.nome }}</td>
        <td class="text-xs-left">
          <input
            v-if="(props.item.flagEstrangeiro) == 0"
            v-mask="(props.item.tipoHabilitador =='J') ? maskCnpj : maskCpf"
            readonly
            :value="props.item.cpfCnpj"
          />
          <input
            v-else
            v-mask="maskDocumentoIdentificacao"
            readonly
            :value="props.item.cpfCnpj"
          />
        </td>
        <td class="text-xs-center">{{ props.item.flagEstrangeiro == "0" ? "Sim" : "Não" }}</td>
        <td class="text-xs-center">{{ props.item.cargo }}</td>
        <td class="text-xs-center">
          <a @click="baixarArquivo(props.item.arquivoUpload)">{{subStrUpload(props.item.arquivoUpload,$t("label.anexo"))}}</a>
        </td>
      </template>
    </v-data-table>
  </v-flex>
</template>



<script>
import util from "../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
import fornecedorService from "../../../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */
export default {
  name: "dirigentes-crud",
  mixins: [util],
  props: {//Propriedades que o objeto recebe como parametro
    model: Object, /*Solicitacao atual do Fornecedor*/
    habilitacaoLista: Object,
    erroHabilitacaoJuridica:Object
  },
  data() {//Declaracao de variaveis
    return {
      crud: false,
      totalDesserts: 0,
      loading: false,
      headers: [ /*Cabeçalho da data-table*/
        {
          text: "Ações",
          align: "center",
          sortable: false,
          width: 70
        },
        {
          text: "Nome",
          align: "left",
          sortable: false,
          width: 250
        },

        {
          text: "CPF",
          align: "left",
          sortable: false,
          width: 100
        },
        {
          text: "Brasileiro?",
          align: "center",
          sortable: false,
          width: 60
        },
        {
          text: "Cargo",
          align: "center",
          sortable: false,
          width: 100
        },
        {
          text: "Anexo",
          align: "center",
          sortable: false,
          width: 100
        }
      ]
    };
  },
  methods: {//Declaracao de todos os metodos
    deleteItem(itemLista) {
        //apagar o dirigente
        fornecedorService
          .deleteFornecedorHabilitacaoJuridica(itemLista.idFornecHabilitacaoJur)
          .then(response => { /*resposta do servico*/
            this.model.fornecedoresHabilitacaoJuridica = response.data; /*dados de retorno*/
            this.habilitacaoLista.sociosLista = [];
            this.habilitacaoLista.dirigentesLista = [];

            this.model.fornecedoresHabilitacaoJuridica.filter(item => {
              if (item.tipoCadastro === "D") {
                this.habilitacaoLista.dirigentesLista.push(item);
              } else {
                this.habilitacaoLista.sociosLista.push(item);
              }
            });
          });
    },
    baixarArquivo(arquivo) {
      //baixar o documento
    const numCgcFornecedor = this.$verificaPerfilCadastrador() ? this.model.numCgcFornecedor.replace(/[\W_]+/g,"") : null;
      fornecedorService.baixarArquivo(arquivo,numCgcFornecedor);
    }
  }
};
</script>